import React, { useEffect, useState } from 'react';
import classes from './styles/firstSection.module.css';

import v1 from "../../assets/firstSec/v1.mp4";
import v2 from "../../assets/firstSec/v2.mp4";

import trainerVideo from "../../assets/firstSec/trainer.mp4";
import motherVideo from "../../assets/firstSec/mother.mp4";

import farmerVideo from "../../assets/firstSec/farmer.mp4";
import meditationVideo from "../../assets/firstSec/meditation.mp4";

import bikerVideo from "../../assets/firstSec/biker.mp4";
import walkingVideo from "../../assets/firstSec/walking.mp4";
import { Link } from 'react-router-dom';


const FirstSection = () => {
const [firstVideo, setFirstVideo] = useState(v1);
const [secondVideo, setSecondVideo] = useState(v2);
const [caption, setCaption] = useState("Get Fit with Susmita \n Anytime, Anywhere. \n Join our online sessions from home, office, or on the go!");

useEffect(() => {
  const videos = [v1, trainerVideo, farmerVideo, bikerVideo];
  const videos2 = [v2, motherVideo, meditationVideo, walkingVideo];
  const captions = ["Get Fit with Susmita \n Anytime, Anywhere. \n Join our online sessions from home, office, or on the go!", "Get fit for what matters. \n Life, Family, Work.", "Get stronger. Get sharper. \n Get more out of life.", "Get your freedom back. \n Do what you love."];
  let index = 0;

  const intervalId = setInterval(() => {
    index = (index + 1) % videos.length;
    setFirstVideo(videos[index]);
    setSecondVideo(videos2[index]);
    setCaption(captions[index]);
  }, 9000);

  return () => clearInterval(intervalId);
}, []);

const scrollToCoach = () => {
  const element = document.getElementById("KnowYourCoachSection");
  if (element) {
    const offset = -80;
    const topPos = element.getBoundingClientRect().top + window.pageYOffset + offset;
    window.scrollTo({ top: topPos, behavior: 'smooth' });
  }
};

const scrollToJoinBtn = () => {
  const element = document.getElementById("JoinNowBtn");
  if (element) {
    const offset = -80;
    const topPos = element.getBoundingClientRect().top + window.pageYOffset + offset;
    window.scrollTo({ top: topPos, behavior: 'smooth' });
  }
};

useEffect(() => {
  const playVideos = async () => {
    try {
      const video1 = document.getElementById(`video1`);
      const video2 = document.getElementById(`video2`);
      
      if (video1) {
        await video1.play().catch(e => console.log('Video1 play failed:', e));
      }
      if (video2) {
        await video2.play().catch(e => console.log('Video2 play failed:', e));
      }
    } catch (error) {
      console.error('Error playing videos:', error);
    }
  };

  // Play immediately and whenever videos change
  playVideos();
  
}, [firstVideo, secondVideo]);


  return (
    <div className={classes.container}>
      <div className={classes.headlineCon} onClick={scrollToJoinBtn}>
        <p className={classes.scrollText}>Online Fitness & Nutrition Coaching – New Batches Going Live This Week! Enroll Now!</p>
      </div>
      <div className={classes.videoCon}>
      <video 
        id="video1"
        src={firstVideo}
        autoPlay={true}
        loop
        muted={true}
        playsInline
        disablePictureInPicture
        disableRemotePlayback
        controls={false}
        className={`${classes.video}`}
        onContextMenu={(e) => e.preventDefault()}
      ></video>

      </div>
      <div className={`${classes.videoCon}`} >
        <video 
          id="video2"
          src={secondVideo} 
          autoPlay={true} 
          loop 
          muted={true}
          playsInline 
          disablePictureInPicture
          className={`${classes.video}`}
          controls={false}
          onContextMenu={(e) => e.preventDefault()}
        ></video>
      </div>
      <div className={`${classes.overlay}`}></div>
      <div className={classes.contentCon}>
        <h1>{caption.split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}</h1>
        <Link onClick={scrollToCoach}>Know Your Coach</Link>
      </div>
    </div>
  )
}

export default FirstSection
